import { render, staticRenderFns } from "./templateOne.vue?vue&type=template&id=0163e3f9&scoped=true"
import script from "./templateOne.vue?vue&type=script&lang=js"
export * from "./templateOne.vue?vue&type=script&lang=js"
import style0 from "./templateOne.vue?vue&type=style&index=0&id=0163e3f9&prod&scoped=scoped&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0163e3f9",
  null
  
)

export default component.exports